// Lesson registry. The six scripted lessons, in teaching order: tiles & families
// → your first run → triplets & the pair → calling Pung → calling Chi → winning.
// The LessonList screen renders this array; each script's deal is engineered so
// its teaching action (discard / claim / tsumo) is legal and reachable — see the
// per-script headers and `lessonScripts.test.ts` for the integrity guarantees.

import type { LessonScript } from '../types.js';
import { lesson1Tiles } from './lesson1Tiles.js';
import { lesson2FirstRun } from './lesson2FirstRun.js';
import { lesson3TripletsPair } from './lesson3TripletsPair.js';
import { lesson4Pung } from './lesson4Pung.js';
import { lesson5Chi } from './lesson5Chi.js';
import { lesson6Winning } from './lesson6Winning.js';

export const LESSON_SCRIPTS: readonly LessonScript[] = [
  lesson1Tiles,
  lesson2FirstRun,
  lesson3TripletsPair,
  lesson4Pung,
  lesson5Chi,
  lesson6Winning,
];
